import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MatchTypeFilterItem = _resolveComponent("MatchTypeFilterItem");
  const _component_SelectedSection = _resolveComponent("SelectedSection");
  const _component_ListSection = _resolveComponent("ListSection");
  const _component_WrapWithDropdownBody = _resolveComponent("WrapWithDropdownBody");
  return _openBlock(), _createBlock(_component_WrapWithDropdownBody, {
    isModified: $props.isModified,
    actionsText: $props.pendingChanges,
    name: $props.title,
    keyword: $props.keyword,
    searchPlaceholder: "Search match types...",
    debounce: false,
    onHidden: _cache[6] || (_cache[6] = $event => _ctx.$emit('hidden')),
    onDiscard: _cache[7] || (_cache[7] = $event => _ctx.$emit('discard')),
    onApply: _cache[8] || (_cache[8] = $event => _ctx.$emit('apply')),
    onCloseDropdown: _cache[9] || (_cache[9] = $event => _ctx.$emit('closeDropdown')),
    onSearch: _cache[10] || (_cache[10] = val => _ctx.$emit('search', val)),
    onRestoreSearch: _cache[11] || (_cache[11] = $event => _ctx.$emit('restoreSearch'))
  }, {
    selected: _withCtx(() => [_createVNode(_component_SelectedSection, {
      title: "Match Type",
      count: $props.selected.length,
      isModified: $props.isModified,
      onClear: _cache[1] || (_cache[1] = $event => {
        _ctx.$emit('clear');
      }),
      onApply: _cache[2] || (_cache[2] = $event => _ctx.$emit('apply')),
      onCloseDropdown: _cache[3] || (_cache[3] = $event => _ctx.$emit('closeDropdown'))
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.selected, ({
        name,
        id
      }) => {
        return _openBlock(), _createBlock(_component_MatchTypeFilterItem, {
          key: id,
          name: name,
          id: id,
          type: name,
          query: $props.keyword,
          selected: "",
          onDeselect: _cache[0] || (_cache[0] = val => _ctx.$emit('deselect', val))
        }, null, 8, ["name", "id", "type", "query"]);
      }), 128))]),
      _: 1
    }, 8, ["count", "isModified"])]),
    list: _withCtx(() => [_createVNode(_component_ListSection, {
      title: "Match Type",
      count: $props.list.length,
      searching: $props.isSearching,
      keyword: $props.keyword
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, ({
        name,
        id
      }) => {
        return _openBlock(), _createBlock(_component_MatchTypeFilterItem, {
          key: id,
          name: name,
          id: id,
          type: name,
          query: $props.keyword,
          onSelect: _cache[4] || (_cache[4] = val => _ctx.$emit('select', val)),
          onSelectOnly: _cache[5] || (_cache[5] = val => _ctx.$emit('selectOnly', val))
        }, null, 8, ["name", "id", "type", "query"]);
      }), 128))]),
      _: 1
    }, 8, ["count", "searching", "keyword"])]),
    _: 1
  }, 8, ["isModified", "actionsText", "name", "keyword"]);
}